// Psychologist/SkillsPicker.tsx
import React from 'react';
import {Box, Checkbox, FormControlLabel, Typography, useMediaQuery} from '@mui/material';
import {useSelector} from 'react-redux';
import {RootState} from "Redux/store";
import {Controller} from 'react-hook-form';
import {FC} from "WideLayout/Layouts";

interface SkillsPickerProps {
    control: any;
}

const SkillsPicker: React.FC<SkillsPickerProps> = ({control}) => {
    const isGtSm = useMediaQuery('(min-width: 576px)');
    const {skill_categories, status} = useSelector((state: RootState) => state.psychologyParams);

    if (status === 'loading') {
        return <Typography>Загрузка тем для обсуждения...</Typography>;
    }

    if (status === 'failed') {
        return <Typography color="error">Ошибка загрузки тем для обсуждения</Typography>;
    }

    return (
        <FC>
            {skill_categories && skill_categories.length > 0 ? (
                skill_categories.map((category) => (
                    <Box key={category.id} mb={2}>
                        <Typography variant="subtitle1" ml={'20%'}>{category.name}</Typography>
                        {/* Заменяем FormGroup на Box с сеткой */}
                        <Box
                            display="grid"
                            gridTemplateColumns="repeat(2, 1fr)"
                            gap={0}
                        >
                            <Controller
                                name="skills"
                                control={control}
                                render={({field}) => (
                                    <>
                                        {category.skills.map((skill) => (
                                            <FormControlLabel
                                                sx={{
                                                    lineHeight: isGtSm ? '' : '.6rem',
                                                    fontSize: isGtSm ? '' : '.6rem'
                                                }}
                                                key={skill.id}
                                                control={
                                                    <Checkbox
                                                        className={'p-1'}
                                                        checked={field.value.includes(skill.id)}
                                                        onChange={(e) => {
                                                            if (e.target.checked) {
                                                                field.onChange([...field.value, skill.id]);
                                                            } else {
                                                                field.onChange(field.value.filter((id: number) => id !== skill.id));
                                                            }
                                                        }}
                                                    />
                                                }
                                                label={<p
                                                    style={{
                                                        margin: '0 auto',
                                                        lineHeight: isGtSm ? '' : '.76rem',
                                                        fontSize: isGtSm ? '' : '.76rem'
                                                    }}>{skill.name}</p>}
                                            />
                                        ))}
                                    </>
                                )}
                            />
                        </Box>
                    </Box>
                ))
            ) : (
                <Typography>Нет доступных тем для обсуждения.</Typography>
            )}
        </FC>
    );
};

export default SkillsPicker;
